<template>
  <svg
    width="183"
    height="145"
    viewBox="0 0 183 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g filter="url(#filter0_d_12276_2959)">
      <rect
        x="12"
        y="3"
        width="159"
        height="110.327"
        rx="3"
        fill="#3E3F46"
      />
      <path
        d="M12 97.1021H171V110.327C171 111.983 169.657 113.327 168 113.327H15C13.3431 113.327 12 111.983 12 110.327V97.1021Z"
        fill="#EFF0F3"
      />
      <rect
        x="73.6536"
        y="113.326"
        width="37.3163"
        height="24.3367"
        fill="#EFF0F3"
      />
      <rect
        x="73.6528"
        y="136.041"
        width="37.3163"
        height="1.62245"
        fill="#D7D8DB"
      />
      <rect
        x="15.2449"
        y="6.24487"
        width="152.51"
        height="87.6122"
        fill="#4D4E58"
      />
    </g>
    <rect
      x="75"
      y="32"
      width="37"
      height="37"
      fill="url(#pattern0_12276_2959)"
    />
    <g filter="url(#filter1_d_12276_2959)">
      <path
        d="M12 97H171V110.224C171 111.881 169.657 113.224 168 113.224H15C13.3431 113.224 12 111.881 12 110.224V97Z"
        fill="#EFF0F3"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_12276_2959"
        x="7"
        y="0"
        width="169"
        height="144.663"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.4875 0 0 0 0 0.4875 0 0 0 0 0.4875 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12276_2959"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12276_2959"
          result="shape"
        />
      </filter>
      <pattern
        id="pattern0_12276_2959"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlink:href="#image0_12276_2959"
          transform="scale(0.005)"
        />
      </pattern>
      <filter
        id="filter1_d_12276_2959"
        x="0"
        y="90"
        width="183"
        height="40.2246"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.486275 0 0 0 0 0.486275 0 0 0 0 0.486275 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12276_2959"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12276_2959"
          result="shape"
        />
      </filter>
      <image
        id="image0_12276_2959"
        width="200"
        height="200"
        xlink:href="data:image/png;base64,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"
      />
    </defs>
  </svg>
</template>
